import React from 'react';

/**
 * Top bar for logged-OUT visitors on the open app routes (/trends, /energy).
 *
 * Those pages render the real components, so without this they'd inherit the
 * authenticated header and Navigation — and a core rule of the anonymous funnel
 * is that logged-out visitors never see the app nav (it advertises features
 * they can't reach and makes the product feel walled). This gives them the
 * brand, a way back to the dashboard, and the two auth actions instead.
 *
 * Wraps at narrow widths rather than absolute-positioning: a previous version
 * of the anonymous bar overlapped the wordmark in mobile portrait and made the
 * buttons unclickable, which is the audience that matters most here.
 */
export default function PublicTopBar() {
  const openAuth = (mode) =>
    window.dispatchEvent(new CustomEvent('alphagrade:show-auth', { detail: { mode } }));

  const btn = {
    background: 'none',
    border: '1px solid var(--border-medium, #334155)',
    color: 'var(--text-primary, #F1F5F9)',
    borderRadius: 8,
    padding: '0.4rem 0.8rem',
    fontWeight: 600,
    fontSize: '0.85rem',
    cursor: 'pointer',
    fontFamily: 'inherit',
  };
  const primary = {
    ...btn,
    background: '#00D4AA',
    borderColor: '#00D4AA',
    color: '#04121C',
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '0.6rem',
        padding: '0.85rem 1rem',
        borderBottom: '1px solid var(--border-primary, #1E293B)',
      }}
    >
      <a
        href="/"
        style={{
          fontSize: '1.15rem',
          fontWeight: 800,
          letterSpacing: '-0.02em',
          textDecoration: 'none',
          color: 'var(--text-primary, #F1F5F9)',
        }}
      >
        <span style={{ color: '#00D4AA' }}>Alpha</span>Grade
      </a>
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        <a href="/" style={{ ...btn, textDecoration: 'none' }}>← Dashboard</a>
        <button style={btn} onClick={() => openAuth('login')}>Sign in</button>
        <button style={primary} onClick={() => openAuth('register')}>Get started free</button>
      </div>
    </div>
  );
}
